import { AxiosResponse } from 'axios';
import BaseApi from '../base/BaseApi';

export default class DeliverooApi extends BaseApi {

    private _isDev: boolean

    constructor(isDev: boolean = false) {
        super("https://partners.deliveroo.com/api/v1/");
        this._isDev = isDev;
    }

    public get isDev(): boolean {
        return this._isDev;
    }

    async getMenu(brandId: string, menuId: string): Promise<AxiosResponse<any>> {
        const target = `/brands/${brandId}/menus/${menuId}`;
        const res = await this.getRequest(target, this.headerWithBasicAuth(this._isDev ? devCredentials : {}));
        return res;
    }

    sendMenu(brandId: string, menuId: string, menuData: any): Promise<AxiosResponse<any>> {
        const target = `/brands/${brandId}/menus/${menuId}`;
        return this.putRequest(target, this.headerWithBasicAuth(this._isDev ? devCredentials : {}), menuData);
    }

    testAuthenticationOnApi(apiKey: string, apiSecret: string): Promise<any> {
        const basicAuthHeader = {
            'auth': {
                'username': apiKey,
                'password': apiSecret
            }
        };
        return this.getRequest('auth/verify', basicAuthHeader).then((res) => {
            return res.data;
        }).catch((err) => {
            return err;
        })
    }

    private headerWithBasicAuth(credentials: any) {
        return {
            'auth': {
                'username': credentials['apiKey'],
                'password': credentials['apiSecret']
            }
        };
    }
}

const devCredentials = {
    apiKey: "azerr",
    apiSecret: "azerrrrr"
};
